export default __webpack_public_path__ + "static/media/House.c3fecd65.svg";